export const PUBLIC_ROUTES = {
	SIGN_UP: '/sign-up',
	AUTHENTICATION: '/authentication',
	CHECK_INBOX: '/check-inbox',
	RESET_PASSWORD: '/reset-password',
	FORGOT_PASSWORD: '/forgot-password',
	CONFIRM_FORGOT_PASSWORD: '/confirm-forgot-password',
	EMAIL_CONFIRMATION: '/email-confirmation',
	API_FEEDBACK_EXTERNAL: '/feedback/external',
	UNREGISTERED_ACCOUNT: '/unregistered-account',
	INVALID_NAMEID: '/invalid-nameid',
	EXTERNAL_KAKAPO_FEEDBACK: '/external/feedback',
	EXTERNAL_FEEDBACK: '/external-feedback',
	SSO: '/sso',
};

// environments
export const DEVELOPMENT_ENV = 'development';

// time
export const DURATION_SCALES = [
	{
		scale: 'hour',
		nextThreshold: 12,
		nextFactor: 24,
	},
	{
		scale: 'day',
		nextThreshold: 14,
		nextFactor: 7,
	},
	{
		scale: 'week',
		nextThreshold: 8,
		nextFactor: 4,
	},
	{
		scale: 'month',
		nextThreshold: 12,
		nextFactor: 12,
	},
	{
		scale: 'year',
	},
];
